/**
 * Wrap an async producer so concurrent callers share one in-flight promise.
 * Once the promise settles, the next call starts a fresh run.
 */
export function singleFlight<T>(fn: () => Promise<T>): () => Promise<T> {
  let inFlight: Promise<T> | null = null;
  return () => {
    if (!inFlight) {
      inFlight = fn().finally(() => {
        inFlight = null;
      });
    }
    return inFlight;
  };
}
